import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { FooterWithMetrics as Footer } from '@zocdoc/components/src/Layout/Footer';

export class View extends React.Component {
    static propTypes = {
        theme: PropTypes.object.isRequired,
    };

    render() {
        const footerTheme = this.props.theme.footer || {};
        return (
            <Footer
                theme={{
                    ...this.props.theme,
                    footer: {
                        ...footerTheme,
                        showPricingLink: false,
                    },
                }}
            />
        );
    }
}

export default withTheme(View);
